import { NO_ROWS_OVERLAY } from '@app/shared/types';

import { XVINoRowsTextOverlay } from './no-rows-text-overlay-components';

export * from './no-rows-text-overlay-components';

export const XVI_NO_ROWS_OVERLAY_COMPONENTS = [XVINoRowsTextOverlay];

export const XVI_NO_ROWS_OVERLAY_MAPPING = {
  [NO_ROWS_OVERLAY.text]: XVINoRowsTextOverlay,
};
